(function() {
    'use strict';

    angular
        .module('portalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('timeseries-data', {
            parent: 'entity',
            url: '/timeseries-data',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.timeseriesData.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/timeseries-data/timeseries-data.html',
                    controller: 'TimeseriesDataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('timeseriesData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('timeseries-data-detail', {
            parent: 'entity',
            url: '/timeseries-data/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'portalApp.timeseriesData.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/timeseries-data/timeseries-data-detail.html',
                    controller: 'TimeseriesDataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('timeseriesData');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TimeseriesData', function($stateParams, TimeseriesData) {
                    return TimeseriesData.get({id : $stateParams.id}).$promise;
                }]
            }
        })
        .state('timeseries-data.new', {
            parent: 'timeseries-data',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/timeseries-data/timeseries-data-dialog.html',
                    controller: 'TimeseriesDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                period: null,
                                date: null,
                                value: null,
                                object_count: null,
                                object_type: null,
                                object_values: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('timeseries-data', null, { reload: true });
                }, function() {
                    $state.go('timeseries-data');
                });
            }]
        })
        .state('timeseries-data.edit', {
            parent: 'timeseries-data',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/timeseries-data/timeseries-data-dialog.html',
                    controller: 'TimeseriesDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TimeseriesData', function(TimeseriesData) {
                            return TimeseriesData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('timeseries-data', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('timeseries-data.delete', {
            parent: 'timeseries-data',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/timeseries-data/timeseries-data-delete-dialog.html',
                    controller: 'TimeseriesDataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TimeseriesData', function(TimeseriesData) {
                            return TimeseriesData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('timeseries-data', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
